export default {
    namespaced: true,
    state: {
        company_condition_company_ids: {},
        access_campaign_company_ids: {},
        access_industry_company_ids: {},
        access_page_group_company_ids: {},
        access_word_company_ids: {},
        access_page_company_ids: {}
    },
    mutations: {
        // company_condition用の企業IDをセット
        setCompanyConditionCompanyIds(state, company_condition_company_ids) {
            state.company_condition_company_ids = company_condition_company_ids;
        },
        // access_campaign用の企業IDをセット
        setAccessCampaignCompanyIds(state, access_campaign_company_ids) {
            state.access_campaign_company_ids = access_campaign_company_ids;
        },
        // access_industry用の企業IDをセット
        setAccessIndustryCompanyIds(state, access_industry_company_ids) {
            state.access_industry_company_ids = access_industry_company_ids;
        },
        // page_group用の企業IDをセット
        setAccessPageGroupCompanyIds(state, access_page_group_company_ids) {
            state.access_page_group_company_ids = access_page_group_company_ids;
        },
        // access_word用の企業IDをセット
        setAccessWordCompanyIds(state, access_word_company_ids) {
            state.access_word_company_ids = access_word_company_ids;
        },
        // access_page用の企業IDをセット
        setAccessPageCompanyIds(state, access_page_company_ids) {
            state.access_page_company_ids = access_page_company_ids;
        }
    },
    actions: {},
    getters: {
        // company_condition用の企業IDを取得
        getCompanyConditionCompanyIds(state) {
            return state.company_condition_company_ids;
        },
        // access_campaign用の企業IDを取得
        getAccessCampaignCompanyIds(state) {
            return state.access_campaign_company_ids;
        },
        // access_industry用の企業IDを取得
        getAccessIndustryCompanyIds(state) {
            return state.access_industry_company_ids;
        },
        // page_group用の企業IDを取得
        getAccessPageGroupCompanyIds(state) {
            return state.access_page_group_company_ids;
        },
        // access_word用の企業IDを取得
        getAccessWordCompanyIds(state) {
            return state.access_word_company_ids;
        },
        // access_page用の企業IDを取得
        getAccessPageCompanyIds(state) {
            return state.access_page_company_ids;
        }
    }
};
